export default function normalizeEpisodeData(data) {
  // Check if the data is already in the normalized format
  if (data.episodeInfo) {
    return data
  }

  // If not, transform it into the expected structure
  return {
    accessibility: data.accessibility,
    programme: data.programme,
    episodeInfo: {
      episodeId: data.id,
      episodeGuid: data.guid,
      programmeGuid: data.programme?.guid,
      name: data.programme?.name,
      title: data.title,
      summary: data.summary,
      startTime: data.schedule?.startTime,
      duration: data.video?._duration,
      availableUntil: data.availability?.until,
      hasSubtitles: Boolean(data._subtitles),
      hasInfoText: Boolean(data.informationText || data.competitionText),
      informationText: data.informationText,
      competitionText: data.competitionText,
      hasGuidanceText: Boolean(data.guidanceText),
      guidanceText: data.guidanceText,
      hasMoreEpisodes: Boolean(data.programme?.availableEpisodes),
      imageId: data.images?.[0]?.id || data.programme?.images?.[0]?.id,
      sportsExclusive: data.premierSportsExclusive,
    },
    video: data.video,
  }
}
